module.exports = __webpack_public_path__ + "static/img/14bg_2.c8fe4e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/14bg_2.png
// module id = 645
// module chunks = 1